import { useNavigate } from "react-router-dom";
import { ArrowLeft, Menu, Home } from "lucide-react";

/**
 * Mobile App-like Header Component
 * Used across all CRM pages for consistent mobile experience
 */
export default function MobileHeader({ 
  title, 
  subtitle,
  icon: Icon,
  iconBg = "from-[#D4A017] to-[#D9A82C]",
  showBack = true,
  showHome = false,
  showMenu = false,
  onMenuClick,
  rightAction,
  className = ""
}) {
  const navigate = useNavigate();

  return (
    <header className={`md:hidden bg-white/95 backdrop-blur-xl sticky top-0 z-40 safe-area-inset-top border-b border-[#C9D4E6] ${className}`}>
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showBack && (
            <button 
              onClick={() => navigate(-1)}
              className="p-2 -ml-2 rounded-xl hover:bg-[#EDF1F8] active:bg-[#E2E9F4] transition-colors"
              aria-label="Go back"
            >
              <ArrowLeft className="h-5 w-5 text-[#3A4557]" />
            </button>
          )}
          {showMenu && (
            <button 
              onClick={onMenuClick}
              className="p-2 -ml-2 rounded-xl bg-[#EDF1F8] hover:bg-[#E2E9F4] active:bg-white transition-colors"
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5 text-[#1B2A4A]" />
            </button>
          )}
          {showHome && (
            <button 
              onClick={() => navigate("/advisor/dashboard")}
              className="p-2 -ml-2 rounded-xl hover:bg-[#EDF1F8] active:bg-[#E2E9F4] transition-colors"
              aria-label="Go to dashboard"
            >
              <Home className="h-5 w-5 text-[#3A4557]" />
            </button>
          )}
          {Icon && (
            <div className={`h-10 w-10 rounded-xl bg-gradient-to-r ${iconBg} flex items-center justify-center flex-shrink-0`}>
              <Icon className="h-5 w-5 text-[#0D1A3A]" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="text-lg font-bold text-[#1B2A4A] truncate">{title}</h1>
            {subtitle && (
              <p className="text-xs text-[#3A4557] truncate">{subtitle}</p>
            )}
          </div>
        </div>
        {rightAction && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {rightAction}
          </div>
        )}
      </div>
    </header>
  );
}

// Export a simpler header for pages that need minimal customization
export function SimpleHeader({ title, onBack }) {
  const navigate = useNavigate();
  
  return (
    <header className="md:hidden bg-white/95 backdrop-blur-xl sticky top-0 z-40 safe-area-inset-top border-b border-[#C9D4E6]">
      <div className="px-4 py-3 flex items-center gap-3">
        <button 
          onClick={onBack || (() => navigate(-1))}
          className="p-2 -ml-2 rounded-xl hover:bg-[#EDF1F8] active:bg-[#E2E9F4] transition-colors"
        >
          <ArrowLeft className="h-5 w-5 text-[#3A4557]" />
        </button>
        <h1 className="text-lg font-bold text-[#1B2A4A]">{title}</h1>
      </div>
    </header>
  );
}
